<template>
  <div class="role">
    <div class="page">
      <div class="page-header white-bg">
        <size-change @sizeChange="sizeChange"></size-change>
        <div class="header-right">
          <vs-input
            class="search-words"
            v-model="words"
              placeholder="ID/渠道名称/渠道编码"
          ></vs-input>
          <vs-button class="search-btn" type="filled" color="primary" @click="toQuery">搜索</vs-button>
          <vs-button type="border" color="primary" @click="addHandle">添加</vs-button>
        </div>
      </div>
      <div class="page-content white-bg">
        <vs-table
          :data="listData">
          <template slot="thead">
            <vs-th class="id-th">
              ID
            </vs-th>
            <vs-th>
              渠道名称
            </vs-th>
            <vs-th>
              渠道编码
            </vs-th>
            <vs-th>
              支付币种
            </vs-th>
            <vs-th>
              渠道协议名称
            </vs-th>
            <vs-th class="key-table-col">
              渠道md5key
            </vs-th>
            <vs-th>
              渠道商户号
            </vs-th>
            <vs-th class="key-table-col">
              回调白名单IP
            </vs-th>
            <vs-th>
              备注
            </vs-th>
            <vs-th>
              创建时间
            </vs-th>
            <vs-th>
              状态
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(tr, index) in data" >
              <vs-td class="id-th">
                {{tr.id}}
              </vs-td>

              <vs-td>
                {{tr.channelName}}
              </vs-td>

              <vs-td>
                <div>{{tr.channelCode}}</div>
              </vs-td>
              <vs-td>
                {{tr.supportCurrency}}
              </vs-td>
              <vs-td>
                {{tr.channelProtocolName}}
              </vs-td>
              <vs-td class="key-table-col">
                {{tr.channelMerMd5Key}}
              </vs-td>
              <vs-td>
                {{tr.channelMerNo }}
              </vs-td>
              <vs-td class="key-table-col">
                {{tr.callbackWhitelistIp}}
              </vs-td>
              <vs-td>
                {{tr.remark || '-' }}
              </vs-td>
              <vs-td>
                {{tr.createTime}}
              </vs-td>
              <vs-td class="status-td">
                <span
                  class="specil-status"
                  :class="{
                    disabled: tr.channelStatus == 1,
                    'no-use': tr.channelStatus == 0 || tr.channelStatus == 2
                   }"
                >{{getState(tr)}}</span>
              </vs-td>
              <vs-td>
                <div class="centerx">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="编辑"
                    placement="top"
                  >
                    <icon-svg
                      icon-class="edit-21"
                      class="pointer edit-icon"
                      @click.native="editHandle(tr)"
                    ></icon-svg>
                  </el-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="pagination-outer" v-if="total">
          <span class="tatol-count">共计{{total}}条</span>
          <vs-pagination
            class="pagination-box"
            :max="size"
            :total="pageSize"
            v-model="page"
          ></vs-pagination>
        </div>
      </div>
    </div>
    <editOrAdd
      :active="active"
      @close="closeHandle"
      :editData="editData"
      :is-edit="isEdit"
      @done-success="doneSuccess"
    ></editOrAdd>
  </div>
</template>

<script>
  import  editOrAdd from '@/components/product/channelManage/editOrAdd'
  import initData from '@/mixins/initData'
  import sizeChange from '@/components/public/sizeChange'
  export default {
    name: "index",
    components:{
      sizeChange,
      editOrAdd,
    },
    data() {
      return {
        addDialogShow: false,
        editData: {},
        active: false,
        isEdit: false,
      }
    },
    mixins: [initData],
    created(){
      this.init();
    },
    methods: {
      beforeInit(){
        this.url = '/pms/crm/pageChannel';
        this.params = {
          page: this.page,
          size: this.size,
        }
        if(this.words){
          this.params.basicInfo = this.words;
        }
        return true;
      },
      getState(tr){
        switch (tr.channelStatus) {
          case 0:
            return '未启用';
          case 1:
            return '启用';
          case 2:
            return '禁用';
        }
      },
      editHandle(tr){
        this.isEdit = true;
        this.editData = tr;
        this.active = true;
      },
      addHandle(){
        this.isEdit = false;
        this.active = true;
      },
      closeHandle(){
        this.active = false;
      },
      doneSuccess(){
        this.init();
      }
    },
  }
</script>
<style lang="scss">
  .role {
    .vs-table--thead th {
      padding-top: 17px!important;
      padding-bottom: 17px!important;
      color: #5E5873;
      background-color: #F3F2F7;
    }
  }
</style>
<style lang="scss" scoped>
  .role-icon {
    margin-left: 10px;
  }
  .vs-self-tooltip {
    display: inline-block;
  }
  .centerx {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .query-box {
    margin-bottom: 1.7rem;
  }
  .page-header {
    .header-right {
      .search-words {
        display: inline-block;
      }
      .search-btn,
      .search-words {
        margin-right: 10px;
      }
    }
  }
  .page-content {
    padding-bottom: 1.4rem;
  }
  .specil-status {
    padding: 2px 5px;
    background: rgba(40, 199, 111, 0.12);
    color: #41B883;
    border-radius: 17px;
    &.no-use {
      background-color: rgba(234, 84, 85, 0.12);
      color: #EA5455;
    }
  }
  .merchant-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;

  }
  .edit-icon {
    font-size: 22px;
  }
  .status-td {
    min-width: 80px;
  }
  .key-table-col {
    max-width: 300px;
    word-wrap: break-word;
    /*word-break: break-all;*/
  }
</style>
